import '../style/Footer.css';

const Footer = () => {
  return (
    <>
      <footer>
        <div className='footer-lines'>
          <div>
            <p>© 2026 Charese Inc.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
